<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Table Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Test Packages" active>
        <h3>Test Packages</h3>
        <test-package-server-table
          :analytes="analyte_collection"
          :sample_types="sample_type_collection"
          :turnaround_sample_type_id="turnaround_sample_type_id"
          :show_columns="[
            'name',
            'sample_type.name',
            'test_package_group.name',
            'description',
            'cost',
            'cost_add_on'
          ]"
        />
      </b-tab>
      <b-tab title="Submissions">
        <h3>Submissions</h3>
        <submission-server-table
          :analytes="analyte_collection"
          :sample_types="sample_type_collection"
          :show_columns="[
            'pid',
            'project.pid',
            'event_code',
            'project.customer.full_name',
            'sample_type.name',
            'test_package.name',
            'sample_count',
            'created_at',
            'received_percent',
            'prepped_percent',
            'scheduled_percent',
            'results_percent'
          ]"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SubmissionServerTable from "@/components/lab/submission/SubmissionServerTable";
import TestPackageServerTable from "@/components/lab/testpackage/TestPackageServerTable";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "TurnaroundDetailCardstack",
  components: {
    TestPackageServerTable,
    SubmissionServerTable
  },
  props: {
    turnaround_sample_type_id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      analyte_collection: null,
      sample_type_collection: null
    };
  },
  methods: {
    async init() {
      const payload = {
        sort: [
          {
            logic: "sortAddAsc",
            field: "name"
          }
        ],
        limit: "all",
        message: this.$bvToast
      };

      this.analyte_collection = await getCollection({
        ...payload,
        collection_type: "analyte"
      });
      this.sample_type_collection = await getCollection({
        ...payload,
        collection_type: "sample_type"
      });

      this.loading = false;
    }
  },
  created() {
    this.loading = true;

    this.init();
  }
};
</script>
